import React from "react";

export default function BottomBorder({ className, width, height }) {
  return (
    <svg
      className={`${className} tbk-block tbk-shrink-0`}
      xmlns="http://www.w3.org/2000/svg"
      width="346"
      height="8"
      viewBox="0 0 346 8"
      role="presentation"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8L346 8.00003L334.555 6.19531C333.731 6.06532 332.897 6.00003 332.063 6.00003L238.188 6.00002C237.075 6.00002 235.974 5.76766 234.956 5.31779L226.359 1.52025C224.142 0.275637 219.664 1.94729e-05 215 1.90652e-05L130.621 1.16886e-05C125.958 1.12809e-05 121.858 0.275629 119.641 1.52024L111.075 5.31453C110.055 5.76651 108.951 6.00001 107.835 6.00001L13.9621 6C13.1293 6 12.2978 6.06502 11.4752 6.19445L0 8Z"
        fill="#72879A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8L346 8.00003L334.555 6.19531C333.731 6.06532 332.897 6.00003 332.063 6.00003L238.188 6.00002C237.075 6.00002 235.974 5.76766 234.956 5.31779L226.359 1.52025C224.142 0.275637 219.664 1.94729e-05 215 1.90652e-05L130.621 1.16886e-05C125.958 1.12809e-05 121.858 0.275629 119.641 1.52024L111.075 5.31453C110.055 5.76651 108.951 6.00001 107.835 6.00001L13.9621 6C13.1293 6 12.2978 6.06502 11.4752 6.19445L0 8Z"
        fill="url(#paint0_linear_25409_9258)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_25409_9258"
          x1="320.5"
          y1="7.99999"
          x2="7"
          y2="-2.00001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#838D98" />
          <stop offset="1" stopColor="#1A1E24" />
        </linearGradient>
      </defs>
    </svg>
  );
}
